import { components } from "@/api-schema";
import { RelocationOrderTransportMethod } from "@/api-schema-enums";
import {
  RelocationOrderFlowRouteType,
  RelocationOrderFlowTransportMethodSegment,
} from "./default-relocation-order-flow.enums";

export type RelocationOrderFlowInitBodyMap = {
  [RelocationOrderFlowRouteType.BranchToBranch]: {
    [RelocationOrderTransportMethod.TransportCompany]: components["schemas"]["BranchToBranchTransportCompanyInitBody"];
    [RelocationOrderTransportMethod.OwnAxle]: components["schemas"]["BranchToBranchOwnAxleInitBody"];
  };
  [RelocationOrderFlowRouteType.BranchToExternalAddress]: {
    [RelocationOrderTransportMethod.TransportCompany]: components["schemas"]["BranchToExternalAddressTransportCompanyInitBody"];
    [RelocationOrderTransportMethod.OwnAxle]: components["schemas"]["BranchToExternalAddressOwnAxleInitBody"];
  };
  [RelocationOrderFlowRouteType.ExternalAddressToBranch]: {
    [RelocationOrderTransportMethod.TransportCompany]: components["schemas"]["ExternalAddressToBranchTransportCompanyInitBody"];
    [RelocationOrderTransportMethod.OwnAxle]: components["schemas"]["ExternalAddressToBranchOwnAxleInitBody"];
  };
};

const TRANSPORT_METHOD_SEGMENT_MAP: Record<RelocationOrderTransportMethod, RelocationOrderFlowTransportMethodSegment> =
  {
    [RelocationOrderTransportMethod.TransportCompany]: RelocationOrderFlowTransportMethodSegment.TransportCompany,
    [RelocationOrderTransportMethod.OwnAxle]: RelocationOrderFlowTransportMethodSegment.OwnAxle,
  };

/**
 * Resolves the API path for a relocation order flow init endpoint.
 *
 * @example
 * resolveRelocationOrderFlowInitPath(RelocationOrderFlowRouteType.BranchToBranch, RelocationOrderTransportMethod.TransportCompany)
 *   → "/v1/relocation-order/flow/branch-to-branch/transport-company/init"
 */
export function resolveRelocationOrderFlowInitPath(
  routeType: RelocationOrderFlowRouteType,
  transportMethod: RelocationOrderTransportMethod,
): string {
  const segment = TRANSPORT_METHOD_SEGMENT_MAP[transportMethod];

  return `/v1/relocation-order/flow/${routeType}/${segment}/init`;
}
